export default "__VITE_ASSET__DiCWdlOV__"